import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const { currentDisplayedTheme } = useTheme();
  
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  // Determine text color based on current displayed theme
  const textColor = currentDisplayedTheme === 'dark' ? 'text-white' : 'text-gray-900';

  return (
    <div className="flex items-center">
      <span className="text-sm text-gray-600 dark:text-gray-400 mr-3">
                {t('language')}:
      </span>
      <div className="flex space-x-3">
        <button
          onClick={() => changeLanguage('en')}
          className={`flex items-center justify-center px-2 py-1 rounded ${
            i18n.language === 'en' 
              ? 'bg-blue-100 dark:bg-blue-900 border border-blue-300 dark:border-blue-700' 
              : 'border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
          aria-label={t('english')}
          title={t('english')}
        >
          <span className="mr-1 text-lg">🇺🇸</span>
          <span className={`text-xs font-medium ${textColor}`}>EN</span>
        </button>
        
        <button
          onClick={() => changeLanguage('es')}
          className={`flex items-center justify-center px-2 py-1 rounded ${
            i18n.language === 'es' 
              ? 'bg-blue-100 dark:bg-blue-900 border border-blue-300 dark:border-blue-700' 
              : 'border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
          aria-label={t('spanish')}
          title={t('spanish')}
        >
          <span className="mr-1 text-lg">🇪🇸</span>
          <span className={`text-xs font-medium ${textColor}`}>ES</span>
        </button>
        
        <button
          onClick={() => changeLanguage('zh')}
          className={`flex items-center justify-center px-2 py-1 rounded ${
            i18n.language === 'zh' 
              ? 'bg-blue-100 dark:bg-blue-900 border border-blue-300 dark:border-blue-700' 
              : 'border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
          aria-label={t('chinese')}
          title={t('chinese')}
        >
          <span className="mr-1 text-lg">🇨🇳</span>
          <span className={`text-xs font-medium ${textColor}`}>ZH</span>
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
